import request from '@/utils/request'

let MemberCardApi = {
    /*充值记录*/
    log(data, errorback) {
        return request._post('/shop/user.MemberCardOrder/index', data, errorback);
    },
}
export default MemberCardApi;


// WEBPACK FOOTER //
// ./src/api/membercard.js